module.exports = __webpack_public_path__ + "static/media/background-productPage.fd01b010.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background/background-productPage.png
// module id = 5912
// module chunks = 0